module.exports = __webpack_public_path__ + "static/img/8.b84c67b8.png";